import { Markdown } from '../Markdown';
import { resolveDescription } from '../utils';
export function OpenAPIOperationDescription(props) {
    var operation = props.operation;
    if (operation['x-gitbook-description-document']) {
        return (<div className="openapi-intro">
                {props.context.renderDocument({
                document: operation['x-gitbook-description-document'],
            })}
            </div>);
    }
    var description = resolveDescription(operation);
    if (!description) {
        return null;
    }
    return (<div className="openapi-intro">
            <Markdown className="openapi-description" source={description}/>
        </div>);
}
